import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class TopicSwitcherConfiguration {
    /**
     * Label für erste Auswahl
     *
     * @example: "Thema dieser Karte wechseln"
     */
    @JsonProperty()
    declare button: string;
    /**
     * Default Topic
     *
     * @example: "Produkt wählen"
     */
    @JsonProperty()
    declare default: string;
    /**
     * Label für erste Auswahl
     *
     * @example: "Thema dieser Karte wechseln"
     */
    @JsonProperty()
    declare description: string;
    /**
     * Label für erste Auswahl
     *
     * @example: "Themen"
     */
    @JsonProperty()
    declare title: string;
    /**
     * Sichtbarkeit des TopicSwitcher
     */
    @JsonProperty()
    declare visible: Array<"compare" | "header" | "legend" | "toc" | "view-manager" > | null;
    constructor() {}
}
